import { InjectionToken } from "@angular/core";

export class ApplicationInfo {
    product: string;
    version: string;
    fileVersion: string;
    copyright: string;
}
export class AppSettings {
    production: boolean;
    baseHref: string = "";
    cookieAuthName: string = "";
    info: ApplicationInfo;

    getUserReportUrl(lang: string): string {
        return "/" + lang + "/myreports/";
    }
}

export const APP_SETTINGS = new InjectionToken<AppSettings>("environment");
